




























import { Component, Vue } from 'vue-property-decorator';
import { Foregrounds } from "./Meta";

@Component({})
export default class Foreground extends Vue {
  selected = 0;
  foregrounds = Foregrounds;
  changeSelection(key: number) {
    this.$emit("change-foreground", key);
  }
}
